<lgb-header-gradient [height]="100" [background]="true"></lgb-header-gradient>
<div class="screen-container" [loading]="loading()">
	<lgb-back name="home"></lgb-back>
	<h1 class="my-4">Paramètres</h1>
	<form>
		<fieldset class="fieldset border-base-300 rounded-box border p-4 glass mb-4">
			<legend class="fieldset-legend px-2">Source des estimations</legend>
			<p>
				Plateforme utilisée pour estimer la valeur de vos cartes.
			</p>
			<select name="market" [(ngModel)]="params().market" class="select" required>
				@for(market of markets(); track market.ref){
					<option [value]="market.ref">{{market.name}}</option>
				}
			</select>
		</fieldset>
		<fieldset class="fieldset border-base-300 rounded-box border p-4 glass mb-4">
			<legend class="fieldset-legend px-2">État par défaut des cartes</legend>
			<p>
				État appliqué automatiquement aux cartes détectées lors d’un scan.
			</p>
			<select name="condition" [(ngModel)]="params().scanCondition" class="select" required>
				@for(cond of conditions(); track cond.ref){
					<option [value]="cond.ref">{{cond.name}}</option>
				}
			</select>
		</fieldset>
		<div class="btn-container mt-4">		
			<button (click)="setParams()" class="btn btn-primary btn-gradient">Valider</button>
		</div>
	</form>
</div>